import { graphql } from "@/lib/gql/__generated__/gql";

export const HotelPolicyEditDefaultQuery = graphql(/* GraphQL */ `
	query HotelPolicy($hotelID: ID!) {
		hotelPolicy(hotelID: $hotelID) {
			id
			checkInStart
			checkInEnd
			checkOut
			amenities
			facilities
			hotelInfo {
				title
				description
			}
			cancelPolicy {
				beforeDays
				chargeRatio
			}
			kidsPolicy {
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			kidsCosleepingPolicy {
				isActive
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			calcAdultPriceAsTotalNum
			questions {
				questionID
				required
				questionType
				question
				options
			}
			hideMailMagazineQuestion
			additionalFees {
				additionalID
				name
				price {
					currencyType
					amount
				}
				billingTypeTerm
				billingTypeTarget
				isNotDiscountTarget
				isNotTargetOnDayTrip
				isExcludeCancelFeeTarget
				isExcludedConsumptionTax
				useKidsPrice
				kidsPrices {
					kidsMaxAge
					price {
						currencyType
						amount
					}
				}
				billingTypeTermValidation
				termValidationApplyStartDt
				termValidationApplyEndDt
			}
			isLocalPaymentAvailable
			localPaymentCancelFeeTransferLimitDays
			localPaymentCancelFeeTransferInfo {
				bankName
				branchName
				bankAccountType
				bankAccountNumber
				bankAccountHolderName
			}
			requiredPrepMillisecond
			baseReservationType
			isShowRoomPriceInCalender
			isShowPlanIncludedPrice
			isShowBestRateNotice
			defaultPlanID
			requiredPlanSelectForReservation
			defaultInitPeopleNum
			isCalendarStartFromAvailableMonth
		}
		customEmailSetting(hotelID: $hotelID) {
			id
			mailFooterExternalLink
			reservation {
				atCreated
				atUpdated
				atCanceled
				atCin
			}
			requestReservation {
				atRequest
				atConfirmed
				atDeclined
			}
			shopping {
				atCreated
			}
		}
		planList(hotelID: $hotelID) {
			id
			plans {
				id
				planID
				inSale
				name
			}
		}
		hotel(hotelID: $hotelID) {
			email
		}
		hotelDisplaySettings(hotelID: $hotelID) {
			id
			hotelID
			isShowCheckInOutTime
			bookedGuestSurveyDisplayStatus
		}
		hotelApplicationStatus(hotelID: $hotelID) {
			isCreditCardRegistered
		}
	}
`);
